import { createEl } from "@/client/utils/createEl";

/**
 * The audio formats a person can pick: the containers the server will stage
 * (see `kAllowedContentTypes` in `shared/upload-url.api.ts`), named by MIME
 * type and by extension so a file with no type still matches.
 *
 * Spelled out rather than `audio/*` on purpose. iOS reads a wildcard that
 * covers a media type as a licence to offer its own capture and photo library
 * sheet ("Take Video", "Photo Library"), none of which yields a file the apps
 * can use. An explicit list of audio types gets the Files browser alone.
 */
export const kAudioFileAccept = [
    "audio/wav",
    "audio/x-wav",
    "audio/mpeg",
    "audio/mp3",
    "audio/aiff",
    "audio/x-aiff",
    "audio/aac",
    "audio/mp4",
    "audio/m4a",
    "audio/x-m4a",
    "audio/flac",
    "audio/x-flac",
    ".wav",
    ".wave",
    ".mp3",
    ".aif",
    ".aiff",
    ".aac",
    ".m4a",
    ".flac",
].join(",");

export const createAudioFileInputEl = (className = "", init?: (el: HTMLInputElement) => void) => {
    const fileInputEl = createEl("input", className, [], (el) => {
        el.type = "file";
        el.accept = kAudioFileAccept;
        init?.(el);
    });
    return fileInputEl;
};
